<template>
  <div class="LaptopEdit">
    <div class="buttons">
      <Btn
        class="ib light"
        :isLoading="isSaving"
        @click="toggleIsArchived">
        {{ laptop.isArchived ? $t('unarchive') : $t('archive') }}
      </Btn>
      <Btn
        class="ib light"
        :isLoading="isSaving"
        @click="isModalOpen = true">
        {{ $t('edit') }}
      </Btn>
      <Btn
        v-if="isSelected"
        class="ib light"
        :class="{ danger: !laptop.price }"
        @click="$emit('replace')">
        {{ $t('replace') }}
      </Btn>
      <template v-if="isPriceOutdated">
        <Btn
          v-if="laptop.price"
          class="ib warning light"
          @click="$emit('syncPrice')">
          {{ $t('syncPrice', [articleLaptop.price, laptop.price]) }}
        </Btn>
        <Route
          :id="laptop.id"
          class="Btn ib danger light"
          to="LaptopFlagged">
          {{ $t('flagged') }}
        </Route>
      </template>
    </div>
    <ModalForm
      v-if="isModalOpen"
      @close="isModalOpen = false"
      @submit="patch(laptopStatic)">
      <FormLaptop
        :laptop.sync="laptopStatic" />
      <Btn :isLoading="isSaving" type="submit">
        {{ $t('save') }}
      </Btn>
    </ModalForm>
  </div>
</template>

<script>
import FormLaptop from '@components/forms/FormLaptop'
import ModalForm from '@components/modals/ModalForm'
import { actions } from '@utils'
import { detach } from '@utils/objects'

export default {
  components: { FormLaptop, ModalForm },
  props: {
    articleLaptop: { type: Object, default: null },
    isSelected: { type: Boolean, default: false },
    laptop: { type: Object, required: true },
  },
  data() {
    return {
      isModalOpen: false,
      isSaving: false,
      laptopStatic: detach(this.laptop),
    }
  },
  computed: {
    isPriceOutdated() {
      return this.articleLaptop?.isPriceCorrect === false
    },
  },
  methods: {
    toggleIsArchived() {
      return this.patch({
        isArchived: !this.laptop.isArchived,
      })
    },
    patch(data) {
      return this.$wrap(
        async () => {
          const laptop = await this.PATCH_LAPTOP({
            id: this.laptop.id,
            ...data,
          })
          this.$emit('patched', laptop)
          this.isModalOpen = false
        },
        'isSaving',
      )
    },
    ...actions('PATCH_LAPTOP'),
  },
}
</script>

<style lang="scss">
.LaptopEdit {
  > .buttons {
    > .Btn {
      margin-right: $uh;

      &:last-of-type {
        margin-right: 0;
      }
    }
  }
}
</style>

<i18n>
{
  "en": {
    "archive": "Archive",
    "unarchive": "Unarchive",
    "edit": "Edit",
    "flagged": "Flagged",
    "replace": "Replace",
    "save": "Save"
  }
}
</i18n>
